// 消息类型
export var msgType;
(function (msgType) {
    msgType["SYS_NOTICE"] = "\u7CFB\u7EDF\u901A\u77E5";
    msgType["PROD_NOTIFY"] = "\u4EA7\u54C1\u901A\u77E5";
    msgType["FINANCE_NOTIFY"] = "\u8D22\u52A1\u901A\u77E5";
})(msgType || (msgType = {}));
// 消息子类型
export var msgSubType;
(function (msgSubType) {
    msgSubType["CONTRACT"] = "contract";
    msgSubType["DEDUCT_RENT"] = "repayment";
    msgSubType["VIOLATION"] = "violation";
    msgSubType["REWARD"] = "REWARD";
    msgSubType["WITHDAW"] = "balance";
})(msgSubType || (msgSubType = {}));
// 业务场景
export var businessScene;
(function (businessScene) {
    businessScene["SYS_NOTICE"] = "SYS_NOTICE";
    businessScene["CONTRACT_NO_SEND"] = "contractQuery?signStatus=UNSEND";
    businessScene["CONTRACT_NO_SIGN"] = "contractQuery?signStatus=UNSIGN";
    businessScene["CONTACT_EXPIRE"] = "contractQuery?activeState=ACTIVE&days=15";
    businessScene["DRIVER_OVERDUE"] = "repaymentQuery?isOverdue=true";
    businessScene["DEDUCT_FAIL"] = "repaymentDetails";
    businessScene["VIOLATION_QUERY_USE_TIMES"] = "violationAnalyze";
    businessScene["VIOLATION_QUERY_RESULT"] = "violationAnalyze";
    businessScene["VIOLATION_QUERY_TIMES_SHORTAGE"] = "violationPurchase";
    businessScene["VIOLATION_QUERY_PURCHASE_SUCCESS"] = "violationPurchaseRecord";
    businessScene["VIOLATION_QUERY_PURCHASE_FAIL"] = "violationPurchaseRecord";
    businessScene["HISTORYVIOLATIONQUERY"] = "historyViolationQuery?status=UNTREATED";
    businessScene["REPEYMENT"] = "repaymentQuery?days=3";
    businessScene["REWARD"] = "driverSupAward";
    businessScene["WITHDRAW_SUCCESS"] = "balanceAccountOverview";
    businessScene["WITHDRAW_FAIL"] = "balanceAccountOverview";
    businessScene["CP_OVERDUE"] = "merchantLoanOrderList?status=OVERDUE";
    businessScene["CP_CONTRACT_NOT_SIGN"] = "merchantLoanOrderList";
})(businessScene || (businessScene = {}));
